import React from 'react';

import MFooterView from './MFooter.view';

interface Props {
  title: string;
 }

const MFooter: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MFooterView title={props.title}>{props.children}</MFooterView>
  );
};

MFooter.displayName = 'MFooter';
MFooter.defaultProps = {};

export default MFooter;
